/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Translation_Import_Action_LabelInputs */



/**
* | output |
* | --- |
* | "Import Translation" |
*
* @param {Translation_Import_Action_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const translation_import_action_label = /** @type {((inputs?: Translation_Import_Action_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Translation_Import_Action_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Importer la traduction")
	if (locale === "de") return /** @type {LocalizedString} */ ("Übersetzung importieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Importa Traduzione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Импорт перевода")
	if (locale === "es") return /** @type {LocalizedString} */ ("Importar traducción")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("导入翻译")
	if (locale === "ja") return /** @type {LocalizedString} */ ("翻訳のインポート")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अनुवाद आयात करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Tradução de Importação")
	return /** @type {LocalizedString} */ ("Import Translation")
});